module.exports = __webpack_public_path__ + "MA.png?8dec9678fd5555eb624b8a40b5bc5181";